import type { ReactNode } from "react";
import { allDocPages } from "../content";
import DocsLayout from "../layout";
import { CoverageTable, Legend } from "./components";

const rows = [
  { market: "FOREX", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Spot Metals", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Binance", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Bitfinex", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Bithumb", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Bitmex", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Bitstamp", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Bittrex", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Cex.io", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Cobinhood", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "gate.io", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "GDAX (Coinbase Pro)", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Gemini", historical: "Y", delayed: "N/A", realTime: "N", level2: "N" },
  { market: "HitBtc", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Huobi", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Kucoin", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "LBank", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "OKCoin", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "OkEx", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Poloniex", historical: "Y", delayed: "N/A", realTime: "N", level2: "N" },
  { market: "Wex.nz (BTC-e)", historical: "Y", delayed: "N/A", realTime: "N", level2: "N" },
  { market: "Kraken", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "BXINTH", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Korbit", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "ErisX", historical: "N", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Seedcx", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Trade.io", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
];

export default function CryptoPage(): ReactNode {
  const page = allDocPages.find(p => p.slug === "data-coverage-crypto")!;
  return (
    <DocsLayout page={page}>
      <Legend/>
      <CoverageTable rows={rows}/>
    </DocsLayout>
  );
}
